module.exports = __webpack_public_path__ + "img/VALOR_INTEGRIDAD2.fefd4ddb.png";